import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
} from '@angular/core';
import {
  BrandsState,
  DeviceCategoryType,
  DeviceFormValue,
} from '@sky/util-models';
import { DeviceFormConfigService } from './device-form-config.service';
import { DeviceFormStateService } from './device-form-state.service';

@Component({
  selector: 'sky-ui-device-form',
  templateUrl: './device-form.component.html',
  styleUrls: ['./device-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DeviceFormConfigService, DeviceFormStateService],
})
export class SkyUiDeviceFormComponent {
  constructor(readonly deviceFormStateService: DeviceFormStateService) {}

  @Input() set deviceTypes(
    deviceTypes: DeviceCategoryType[] | null | undefined
  ) {
    this.deviceFormStateService.setDeviceTypes(deviceTypes);
  }

  @Input() set brands(brands: BrandsState | undefined) {
    this.deviceFormStateService.setBrands(brands);
  }

  @Input() set deviceCategory(category: string) {
    this.deviceFormStateService.setCategory(category);
  }

  @Input() set initialFormValue(
    initialFormValue: DeviceFormValue | null | undefined
  ) {
    this.deviceFormStateService.setInitialFormData(initialFormValue);
  }

  @Output() deviceTypeChanges = this.deviceFormStateService.deviceTypeValue$;

  @Output() form = this.deviceFormStateService.form$;

  readonly vm$ = this.deviceFormStateService.vm$;
}
